import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "App";
import { MaterialUIControllerProvider } from "context";

// Create a QueryClient instance
const queryClient = new QueryClient();

const container = document.getElementById("app");
const root = createRoot(container);
document.title = "Haram Store";

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
